import { useMemo } from 'react'

import { displayOrganizationHeadquarters, displayOrganizationOperatingLocations } from '../locations/helpers'
import {
  displayOrganizationBusinessModels,
  displayOrganizationEnablers,
  displayOrganizationSectors,
  getOrganizationStage,
} from '../organizations/helpers'
import { Organization } from '../organizations/types'

export function useCompanyInfo(organization: Organization) {
  const organizationSectors = useMemo(() => displayOrganizationSectors(organization), [organization])
  const organizationEnablers = useMemo(() => displayOrganizationEnablers(organization), [organization])
  const organizationBusinessModels = useMemo(() => displayOrganizationBusinessModels(organization), [organization])
  const organizationHeadquarters = useMemo(() => displayOrganizationHeadquarters(organization), [organization])
  const organizationOperatingLocations = useMemo(() => displayOrganizationOperatingLocations(organization), [
    organization,
  ])
  const organizationStage = useMemo(() => getOrganizationStage(organization), [organization])
  return {
    organizationId: organization.id,
    organizationName: organization.name,
    organizationDomain: organization.domain,
    organizationBlurb: organization.blurb,
    organizationSectors,
    organizationEnablers,
    organizationBusinessModels,
    organizationHeadquarters,
    organizationOperatingLocations,
    organizationStage,
  }
}
